import i18next from "i18next";
import type { $ZodErrorMap } from "zod/v4/core";
import { Resources, getResourcePath } from "Translations/Resources";

const RESOURCES = Resources.ValidationMessages;

export const zodCustomErrorMap: $ZodErrorMap = (issue) => {
  const { code, expected, maximum, minimum, origin, format } = issue;

  switch (code) {
    case "invalid_type":
      if (
        expected === "nonoptional" ||
        issue.input === undefined ||
        issue.input === null
      ) {
        return i18next.t(getResourcePath(RESOURCES.Required));
      }
      break;
    case "invalid_value":
      if (issue.input === null || issue.input === undefined) {
        return i18next.t(getResourcePath(RESOURCES.Required));
      }
      break;
    case "too_small":
      if (origin === "array" && minimum === 1) {
        return i18next.t(getResourcePath(RESOURCES.ArrayMinOne));
      }
      if (origin === "string" && minimum === 1) {
        return i18next.t(getResourcePath(RESOURCES.Required));
      }
      if (origin === "string") {
        return i18next.t(getResourcePath(RESOURCES.TooSmallString), {
          minimum: String(minimum),
        });
      }
      break;
    case "too_big":
      if (origin === "string") {
        return i18next.t(getResourcePath(RESOURCES.TooBigString), {
          maximum: String(maximum),
        });
      }
      break;
    case "invalid_format":
      if (format === "email") {
        return i18next.t(getResourcePath(RESOURCES.InvalidEmail));
      }
      if (format === "url") {
        return i18next.t(getResourcePath(RESOURCES.InvalidUrl));
      }
      break;
  }
  return undefined;
};
